import { render } from "./MbaMarkFin.vue?vue&type=template&id=665f5f21"
import script from "./MbaMarkFin.vue?vue&type=script&lang=js"
export * from "./MbaMarkFin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__